// re-exporting for naming consistency
import { AccessRight as ACLEnum } from '@uniqkey-backend-partner/api-client';

export default ACLEnum;
